import React from 'react';

// Routes
import Routes from './content-courses-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
